<template>
  <div>
    <Loader ref="Loader"></Loader>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense color="secondary" dark>
          <v-toolbar-title>Detailed Report</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- FILTER -->
        <v-flex xs12 sm12 lg12>
          <v-card elevation-5 dark>
            <v-card-title class="title">Filters</v-card-title>
            <v-layout ma-2>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-combobox label="Select customer" v-model="selectedCustomer" :items="customerItems" item-text="Name"
                  item-value="ID" @change="FetchVenues()"></v-combobox>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-combobox label="Select venue" v-model="selectedVenue" :items="venueItems" item-text="Name"
                  item-value="ID" :disabled="selectedCustomer == null"></v-combobox>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="startDateFormatted" label="Start Date" hint="MM/DD/YYYY format" persistent-hint
                      prepend-icon="event" @blur="startDate = parseStartDate(startDateFormatted)"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu ref="menu1" v-model="menu2" :close-on-content-click="false" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="endDateFormatted" label="End Date" hint="MM/DD/YYYY format" persistent-hint
                      prepend-icon="event" @blur="endDate = parseEndDate(endDateFormatted)" v-on="on"></v-text-field>
                  </template>
                  <!-- <v-date-picker v-model="endDate" no-title @input=""> -->
                  <v-date-picker v-model="endDate" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout justify-end ma-2 row>
              <v-btn flat outline @click="filterItems()">Filter</v-btn>
              <v-btn flat outline @click="clearFilter()">Clear Filter</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
        <v-layout row wrap ma-2>
          <!-- Widgets-->
          <v-flex d-flex lg3 sm6 xs12>
            <widget icon="domain" :count="CheckInsForToday" supTitle="Total check-ins for the selected period"
              color="#00b297" />
          </v-flex>
          <v-flex d-flex lg3 sm6 xs12>
            <widget icon="work" :count="SupervisorInspectionsCompletedToday"
              supTitle="Total supervisor tasks submitted for the selected period" color="#dc3545" />
          </v-flex>
          <v-flex d-flex lg3 sm6 xs12>
            <widget icon="group_work" :count="OpsInspectionsCompletedToday"
              supTitle="Total ops-manager tasks submitted for the selected period" color="#0866C6" />
          </v-flex>
          <v-flex d-flex lg3 sm6 xs12>
            <widget icon="watch_later" :title="CompleteIncomplete.Efficiency"
              supTitle="Supervisor efficiency of tasks complete vs tasks incomplete" color="#1D2939" />
          </v-flex>
          <!-- <v-flex d-flex lg4 sm6 xs12>
            <site-view-statistic />
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12>
            <location-statistic />
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12>
            <total-earnings-statistic />
          </v-flex>-->
          <v-layout ma-2>
            <v-flex xs3>
              <h3>Supervisor Tasks</h3>
            </v-flex>
          </v-layout>
          <v-container>
            <v-flex xs4>
              <v-text-field append-icon="search" v-model="search" placeholder="Search supervisor tasks"></v-text-field>
            </v-flex>
            <v-flex d-flex lg12 sm12 xs12>
              <v-data-table class="table" :headers="superVisorHeaders" :items="superVisorItems"
                :rows-per-page-items="[25, 50, 100]" :search="search">
                <template v-slot:items="props">
                  <td>{{ props.index + 1 }}</td>
                  <td class="text-xs-left">{{ props.item.Date }}</td>
                  <td class="text-xs-left">{{ props.item.Supervisor }}</td>
                  <td class="text-xs-left">{{ props.item.Inspection }}</td>
                  <td class="text-xs-left">{{ props.item.Reference }}</td>
                  <td class="text-xs-left">{{ props.item.InspectionItem }}</td>
                  <td class="text-xs-left">{{ props.item.Completed }}</td>
                  <td class="text-xs-left">{{ props.item.Comments }}</td>
                  <td class="text-xs-left" v-if="props.item.FilePath != null && props.item.FilePath.length > 0">
                    <v-btn flat outline color="secondary" @click="showImage(props.item.ID)">View photo</v-btn>
                  </td>
                  <td class="text-xs-left" v-else>No Image</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-container>
          <v-layout ma-2>
            <v-flex xs3>
              <h3>Ops Manager Tasks</h3>
            </v-flex>
          </v-layout>
          <v-container>
            <v-flex xs4>
              <v-text-field append-icon="search" v-model="searchOps" placeholder="Search supervisor tasks"></v-text-field>
            </v-flex>
            <v-flex d-flex lg12 sm12 xs12>
              <v-data-table class="table" :headers="opsManagerItemHeaders" :items="opsManagerItems"
                :rows-per-page-items="[25, 50, 100]" :search="searchOps">
                <template v-slot:items="props">
                  <td>{{ props.index + 1 }}</td>
                  <td class="text-xs-left">{{ props.item.DateTime }}</td>
                  <td class="text-xs-left">{{ props.item.OpsManager }}</td>
                  <td class="text-xs-left">{{ props.item.Type }}</td>
                  <td class="text-xs-left">{{ props.item.Inspection }}</td>
                  <td class="text-xs-left">{{ props.item.Complete }}</td>
                  <td class="text-xs-left">{{ props.item.CustomerComments }}</td>
                  <td class="text-xs-left">{{ props.item.OpsComments }}</td>
                  <td class="text-xs-left">{{ props.item.CustomerRating }}</td>
                  <td class="text-xs-left">{{ props.item.OpsRating }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-container>
          <!-- <v-flex d-flex lg4 sm6 xs12>
            <time-line />
          </v-flex>-->
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog v-model="showPhoto" max-width="600px">
      <v-flex xs12>
        <v-card>
          <v-toolbar dense color="secondary" dark>
            <v-toolbar-title>Photo Taken</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-layout fill-height>
            <v-img v-if="photoUrl != null" :src="photoUrl"></v-img>
          </v-layout>
        </v-card>
      </v-flex>
    </v-dialog>
  </div>
</template>

<script>
import Widget from "./report-components/Widget.vue";
import DataTable from "./report-components/DataTable.vue";
import TimeLine from "./report-components/TimeLine.vue";
import LocationStatistic from "./report-components/LocationStatistic.vue";
import SiteViewStatistic from "./report-components/SiteViewStatistic.vue";
import TotalEarningsStatistic from "./report-components/TotalEarningsStatistic.vue";
import moment from "moment";
import JWT from "jsonwebtoken";

export default {
  data() {
    return {
      role: null,
      userID: 0,
      date: null,
      startDate: null,
      endDate: null,
      // startDate: new Date(this.date.getFullYear(), this.date.getMonth(), 1).toISOString().substr(0, 10),
      // endDate: new Date().toISOString().substr(0, 10),
      startDateFormatted: this.formatStartDate(
        new Date().toISOString().substr(0, 10)
      ),
      endDateFormatted: this.formatEndDate(
        new Date().toISOString().substr(0, 10)
      ),
      menu1: false,
      menu2: false,
      CheckInsForToday: 0,
      today: moment(Date.now()).format("YYYY-MM-DD"),
      customerItems: [],
      selectedCustomer: null,
      venueItems: [],
      selectedVenue: null,
      NumberOfCompletedSupervisorTasksForToday: null,
      SupervisorInspectionsCompletedToday: 0,
      NumberOfCompletedOpsTasksForToday: null,
      OpsInspectionsCompletedToday: 0,
      CompleteIncomplete: {
        Complete: 0,
        Incomplete: 0,
        Total: 0,
        Efficiency: ""
      },
      superVisorItems: [],
      opsManagerItems: [],
      superVisorHeaders: [
        {},
        {
          value: "Date",
          text: "Date",
          align: "left",
          sortable: true
        },
        {
          text: "Supervisor",
          value: "Supervisor",
          align: "left",
          sortable: true
        },
        {
          text: "Inspection",
          value: "Inspection",
          align: "left",
          sortable: true
        },
        {
          text: "Reference",
          value: "Reference",
          align: "left",
          sortable: true
        },
        {
          text: "Inspection Item",
          value: "InspectionItem",
          align: "left",
          sortable: true
        },
        {
          text: "Completed",
          value: "Completed",
          align: "left",
          sortable: true
        },
        {
          text: "Comments",
          value: "Comments",
          align: "left",
          sortable: true
        },
        {
          text: "FilePath",
          value: "FilePath",
          align: "left",
          sortable: true
        }
      ],
      opsManagerItemHeaders: [
        {},
        {
          value: "DateTime",
          text: "Date",
          align: "left",
          sortable: true
        },
        {
          text: "Ops Manager",
          value: "OpsManager",
          align: "left",
          sortable: true
        },
        {
          text: "Type",
          value: "Type",
          align: "left",
          sortable: true
        },
        {
          text: "Inspection",
          value: "Inspection",
          align: "left",
          sortable: true
        },
        {
          text: "Complete",
          value: "Complete",
          align: "left",
          sortable: true
        },
        {
          text: "Customer Comments",
          value: "CustomerComments",
          align: "left",
          sortable: true
        },
        {
          text: "Ops Manager Comments",
          value: "OpsComments",
          align: "left",
          sortable: true
        },
        {
          text: "Customer Rating",
          value: "CustomerRating",
          align: "left",
          sortable: true
        },
        {
          text: "Ops Manager Rating",
          value: "OpsRating",
          align: "left",
          sortable: true
        }
      ],
      showPhoto: false,
      photoUrl: null,
      search: null,
      searchOps: null
    };
  },
  components: {
    Widget,
    DataTable,
    TimeLine,
    LocationStatistic,
    SiteViewStatistic,
    TotalEarningsStatistic
  },
  computed: {
    computedDateFormatted() {
      return this.formatStartDate(this.startDate);
      return this.formatEndDate(this.endDate);
    }
  },
  watch: {
    startDate(val) {
      this.startDateFormatted = this.formatStartDate(this.startDate);
    },
    endDate(value) {
      this.endDateFormatted = this.formatEndDate(this.endDate);
    }
  },
  mounted() {
    let self = this;
    let tokenDecoded = JWT.decode(localStorage.accessToken);
    console.log("[TOKEN DECODED]", tokenDecoded);

    self.userID = localStorage.getItem("USER_ID");
    console.log("USER_ID", self.userID);
    self.role = localStorage.getItem("Role");
    console.log("ROLE", self.role);

    var date = new Date();
    self.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
      .toISOString()
      .substr(0, 10);
    self.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      .toISOString()
      .substr(0, 10);

    self.FetchCustomers(self.role, self.userID);

    //self.getCheckIns(role, userID);
    //self.getSupervisorTotalTasksCompletedForToday(self.role, self.userID);
    //self.getOpsManagerTasksCompletedForToday(self.role, self.userID);
  },
  methods: {
    showImage(id) {
      let self = this;
      self.showPhoto = true;
      let address = self.$Config.ServerAddress;
      console.log("address", address);
      self.photoUrl = `${address}Photo/Stream?id=${id}`;
    },
    FetchCustomers(role, userID) {
      let self = this;

      let url;

      switch (role.toLowerCase()) {
        case "master":
          {
            url = `Customer`;
          }
          break;
        case "admin":
          {
            url = `Customer`;
          }
          break;
        default:
          {
            url = `Customer/GetBySystemUser?systemUserID=${self.userID}`;
          }
          break;
      }

      if (role == "Master" || role == "Admin") {
        self
          .get(`Customer`)
          .then(response => {
            self.customerItems = response.data;
            console.log("[CUSTOMER ITEMS]", self.customerItems);
          })
          .catch(error => {
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });
      } else {
        self
          .get(`Customer/GetBySystemUser?systemUserID=${self.userID}`)
          .then(response => {
            self.customerItems = response.data;
            console.log("[CUSTOMER ITEMS]", self.customerItems);
          })
          .catch(error => {
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });
      }
    },
    FetchVenues() {
      let self = this;

      self.$nextTick(() => {
        self
          .get(
            `CustomerVenue/CustomerID?customerID=${self.selectedCustomer.ID}`
          )
          .then(r => {
            console.log("[VENUE ITEMS FOR CUSTOMER]", r.data);
            self.venueItems = r.data;
          });
      });
    },
    filterItems() {
      let self = this;

      if (self.selectedCustomer.ID != null && self.selectedVenue.ID != null) {
        self.$refs.Loader.show(true);
        self.$refs.Loader.setText("Filtering items...");
        console.log("SELECTED DATES", self.startDate, self.endDate);
        self.menu2 = false;
        self.getCheckIns();
        self.getSupervisorTotalTasks();
        self.getOpsTotalTasks();
        self.getCompleteVsIncomplete();
        self.getSupervisorTasks();
        self.getOpsManagerTasks();
        setTimeout(() => {
          self.$refs.Loader.hide();
        }, 2000);
      }
    },
    clearFilter() {
      let self = this;
      self.selectedCustomer = null;
      self.selectedVenue = null;
      self.opsManagerItems = [];
      self.superVisorItems = [];
      self.CheckInsForToday = 0;
      self.SupervisorInspectionsCompletedToday = 0;
      self.OpsInspectionsCompletedToday = 0;
      self.CompleteIncomplete.Efficiency = "";
    },
    getCheckIns() {
      let self = this;

      // TODO GET FOR OTHER ROLES/USER
      if (self.role == "Master" || self.role == "Admin") {
        self
          .get(
            `SQLReporting/TotalCheckInsByVenue?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
          )
          .then(r => {
            console.log("wtf is this", r);
            self.CheckInsForToday = r.data.length;
          });
      }
    },
    getSupervisorTotalTasks() {
      let self = this;

      var inspectionCompletedCount = 0;
      self.SupervisorInspectionsCompletedToday = 0;
      // TODO GET FOR OTHER ROLES/USER
      if (self.role == "Master" || self.role == "Admin") {
        self
          .get(
            `SQLReporting/TotalSupervisorTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
          )
          .then(r => {
            console.log("[SUPERVISOR TASKS]", r.data);
            r.data.forEach(el => {
              inspectionCompletedCount =
                inspectionCompletedCount + el.TotalJobsComplete;
            });
            self.SupervisorInspectionsCompletedToday = inspectionCompletedCount;
            console.log(
              "SUPERVISOR TASKS COMPLETED",
              self.SupervisorInspectionsCompletedToday
            );
          });
      }
    },
    getOpsTotalTasks() {
      let self = this;

      self
        .get(
          `SQLReporting/TotalOpsInspectionTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("OPS MANAGER TOTAL", r);
          self.OpsInspectionsCompletedToday = r.data[0].TotalCustomerVisits;
        });
    },
    getCompleteVsIncomplete() {
      let self = this;

      self
        .get(
          `SQLReporting/SupervisorCompleteVsInComplete?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("[COMPLETE VS INCOMPLETE]", r);

          self.CompleteIncomplete.Complete = r.data[0].TotalComplete;
          self.CompleteIncomplete.Incomplete = r.data[0].TotalIncomplete;
          self.$nextTick(() => {
            self.CompleteIncomplete.Total =
              self.CompleteIncomplete.Complete +
              self.CompleteIncomplete.Incomplete;

            if (self.CompleteIncomplete.Total > 0) {
              self.CompleteIncomplete.Efficiency =
                parseFloat(
                  (self.CompleteIncomplete.Complete /
                    self.CompleteIncomplete.Total) *
                  100
                ).toFixed(2) + "%";
            }
          });

          console.log("COMPLETE/INCOMPLETE", self.CompleteIncomplete);
        });
    },
    getSupervisorTasks() {
      let self = this;

      self
        .get(
          `SQLReporting/SupervisorTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("[SUPERVISOR TASKS FOR TABLE]", r.data);
          self.superVisorItems = r.data;

          self.superVisorItems.forEach(task => {
            task.Date = moment(task.Date).format("YYYY-MM-DD hh:mm:ss");

            if (task.Comments == null || task.Comments.length == 0) {
              task.Comments = "No comments submitted";
            }
          });
        });
    },
    getOpsManagerTasks() {
      let self = this;

      console.log(self.selectedVenue.ID);

      self
        .get(
          `SQLReporting/OpsManagerTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("[OPS-MANAGER] TASKS FOR TABLE", r.data);
          self.opsManagerItems = r.data;
          self.opsManagerItems.forEach(task => {
            task.DateTime = moment(task.DateTime).format("YYYY-MM-DD");

            task.OpsRating = task.OpsRating + "/5";

            if (task.Inspection == null) {
              task.Inspection = "N/A";
            }

            if (task.Type == 1) {
              task.Type = "Customer Visit";
              task.OpsRating = "N/A";
            } else if (task.Type == 2) {
              task.Type = "Inspection";
            }

            if (task.CustomerComments == null) {
              task.CustomerComments = "N/A";
            }

            if (task.OpsComments == null) {
              task.OpsComments = "N/A";
            }

            if (task.CustomerRating == 1) {
              task.CustomerRating = "Good";
            } else if (task.CustomerRating == 0) {
              task.CustomerRating = "Bad";
            }

            if (task.CustomerRating == "Bad" && task.Type == "Inspection") {
              task.CustomerRating = "N/A";
            }

            if (task.OpsRating == null) {
              task.OpsRating = 0;
            }
          });
        });
    },
    // DATE FILTERING
    parseDate(date) {
      let self = this;
      console.log("PARSED DATE", date);
    },
    filterByDate() {
      let self = this;
      var labels = [];
      var data = [];

      console.log("[FILTER START DATE]", self.startDate);
      console.log("[FILTER END DATE]", self.endDate);
    },
    formatStartDate(startDate) {
      if (!startDate) return null;

      const [year, month, day] = startDate.split("-");
      return `${month}/${day}/${year}`;
    },
    formatEndDate(endDate) {
      if (!endDate) return null;

      const [year, month, day] = endDate.split("-");
      return `${month}/${day}/${year}`;
    },
    parseStartDate(startDate) {
      if (!startDate) return null;

      const [month, day, year] = startDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    parseEndDate(endDate) {
      if (!endDate) return null;

      const [month, day, year] = endDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

<style></style>